export default __webpack_public_path__ + "static/media/logo-light.ca4d9dde.png";